import R from "./objectWithoutPropertiesLoose3.mjs";
import f from "./extends3.mjs";
import * as d from "react";
import o from "./index180.mjs";
import { PickersToolbar as g } from "./PickersToolbar.mjs";
import { useUtils as k, useLocaleText as D } from "./useUtils.mjs";
import { getDatePickerToolbarUtilityClass as w } from "./datePickerToolbarClasses.mjs";
import { resolveDateFormat as x } from "./date-utils.mjs";
import { jsx as u } from "react/jsx-runtime";
import b from "./styled.mjs";
import O from "./Typography.mjs";
import L from "./useThemeProps.mjs";
import q from "./composeClasses.mjs";
const C = ["value", "isLandscape", "onChange", "toolbarFormat", "toolbarPlaceholder", "views"], _ = (r) => {
  const {
    classes: e
  } = r;
  return q({
    root: ["root"],
    title: ["title"]
  }, w, e);
}, j = b(g, {
  name: "MuiDatePickerToolbar",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})({}), F = b(O, {
  name: "MuiDatePickerToolbar",
  slot: "Title",
  overridesResolver: (r, e) => e.title
})(({
  ownerState: r
}) => f({}, r.isLandscape && {
  margin: "auto 16px auto auto"
})), N = /* @__PURE__ */ d.forwardRef(function(e, i) {
  const t = L({
    props: e,
    name: "MuiDatePickerToolbar"
  }), {
    value: s,
    isLandscape: l,
    toolbarFormat: n,
    toolbarPlaceholder: c = "––",
    views: m
  } = t, T = R(t, C), a = k(), y = D(), p = _(t), h = d.useMemo(() => {
    if (!s)
      return c;
    const v = x(a, {
      format: n,
      views: m
    }, !0);
    return a.formatByString(s, v);
  }, [s, n, c, a, m]), P = t;
  return /* @__PURE__ */ u(j, f({
    ref: i,
    toolbarTitle: y.datePickerToolbarTitle,
    isLandscape: l,
    className: p.root
  }, T, {
    children: /* @__PURE__ */ u(F, {
      variant: "h4",
      align: l ? "left" : "center",
      ownerState: P,
      className: p.title,
      children: h
    })
  }));
});
process.env.NODE_ENV !== "production" && (N.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  classes: o.object,
  /**
   * className applied to the root component.
   */
  className: o.string,
  disabled: o.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: o.bool,
  isLandscape: o.bool.isRequired,
  onChange: o.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: o.func.isRequired,
  readOnly: o.bool,
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  titleId: o.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: o.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: o.node,
  value: o.any,
  /**
   * Currently visible picker view.
   */
  view: o.oneOf(["day", "month", "year"]).isRequired,
  views: o.arrayOf(o.oneOf(["day", "month", "year"]).isRequired).isRequired
});
export {
  N as DatePickerToolbar
};
//# sourceMappingURL=DatePickerToolbar.mjs.map
